module.exports = __webpack_public_path__ + "static/media/nl.e336d50a.svg";